import { render } from "./CircularImage.vue?vue&type=template&id=72dffe28&scoped=true&ts=true"
import script from "./CircularImage.vue?vue&type=script&lang=ts"
export * from "./CircularImage.vue?vue&type=script&lang=ts"

import "./CircularImage.vue?vue&type=style&index=0&id=72dffe28&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72dffe28"]])

export default __exports__